import { Accordion, Icon, Text, TextVariants } from "@centricsoftware/design-system";
import clsx from "clsx";
import { Box, FlexColumn } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import ConfigurationEditView from "./ConfigurationEditView";
import FormAttributeDetails from "./FormAttributeDetails";
import panelCss from "./FormAttributesPanel.module.css";
import FormAttributesReadOnlyView from "./FormAttributesReadOnlyView";
import { useFormDefinitionStore } from "./FormDefinitionStore";
import formCss from "./SelectableFormFields.module.css";

export const FormAttributesPanel: FC = observer(() => {
	const { isEditFormDefinitionMode } = useFormDefinitionStore();

	return (
		<FlexColumn className={clsx(formCss.drawerNodeContainer, formCss.drawerNodeContainerRight)} p={4}>
			<Box p={4}>
				<Text
					childrenRes={{ res: "FormBuilderAttributeDetails" }}
					variant={TextVariants.HeadingPrimary}
				/>
			</Box>
			<Accordion
				defaultExpanded
				// TODO DS: Add support for React nodes in Accordion title.
				// @ts-ignore
				title={(
					<Box className={panelCss.titleRow}>
						<Icon
							className={panelCss.titleIcon}
							name="info"
							size={20}
						/>
						<Text
							childrenRes={{ res: "Info" }}
							variant={TextVariants.UiBold}
						/>
					  </Box>
				)}
			>
				<FormAttributeDetails />
			</Accordion>
			<Accordion
				defaultExpanded
				// TODO DS: Add support for React nodes in Accordion title.
				// @ts-ignore
				title={(
					<Box className={panelCss.titleRow}>
						<Icon
							className={panelCss.titleIcon}
							name="settings"
							size={20}
						/>
						<Text
							childrenRes={{ res: "Configuration" }}
							variant={TextVariants.UiBold}
						/>
					  </Box>
				)}
			>
				{isEditFormDefinitionMode ? <ConfigurationEditView /> : <FormAttributesReadOnlyView />}
			</Accordion>
		</FlexColumn>
	);
});
